import { Component, Input } from '@angular/core';
import { Allergens } from 'src/interfaces/enums.model';

/**
 * Аллергены названиями — «таблетки» с иконкой, без фона блока: в карточке блюда (item)
 * и над добавками (addons) — различаются только отступами
 */
@Component({
    selector: 'app-allergen-list',
    templateUrl: './menu-allergen-list.component.html',
    styleUrls: ['./menu-allergen-list.component.css'],
    standalone: false
})
export class MenuAllergenListComponent {
  @Input() allergens: Allergens[] = [];
  /** Ключ перевода заголовка */
  @Input() title: string = 'allergens';
  @Input() variant: 'item' | 'addons' = 'item';
}
